import makeApiRequest from './makeApiCall';

export const getAllIncomeStatement = async (data) => {
  return await makeApiRequest(
    `/ledger/other-reports/income-statement`,
    'POST',
    null,
    data,
    false,
  );
};

//accounts dropdown
export const getAccountList = async (data) => {
  //endpoint => declaration of api
  return await makeApiRequest(`/ledger/accountcode-list`, 'GET', null, data);
};

export const getIncomeStatementV1 = async (params) => {
  return await makeApiRequest(
    `/coa/financial-statement/income-statement/lists`,
    'GET',
    null,
    params,
  );
};

export const getIncomeStatementV1Export = async (params) => {
  return await makeApiRequest(
    `/coa/financial-statement/income-statement/export`,
    'GET',
    null,
    params,
  );
};
